import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const AmazonProductListing = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14932)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECFEFF"
          />
          <rect
            x="72.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            fill="white"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M161.188 47L74 100.2C74 100.2 74.6124 101.655 75.7024 102.18C76.7925 102.705 78.2709 103 79.8125 103H161.188C162.729 103 164.208 102.705 165.298 102.18C166.388 101.655 167 100.943 167 100.2V49.8C167 49.0574 166.388 48.3452 165.298 47.8201C164.208 47.295 161.188 47 161.188 47Z"
            fill="#E3E3E3"
          />
          <path
            d="M95.674 59.9957H129.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.674 67.71H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.674 75.4243H129.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.674 83.1386H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M95.674 90.8529H139.674"
            stroke="#191919"
            strokeWidth="1.92857"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="72.75"
            y="46.75"
            width="94.5"
            height="56.5"
            rx="4.39286"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M50.5961 60.6141L53.0015 63.0195L61.0194 55.0016L58.614 52.5962C57.545 51.5613 56.112 50.9881 54.6241 51.0002C53.1363 51.0123 51.7128 51.6087 50.6607 52.6608C49.6086 53.7129 49.0122 55.1364 49.0001 56.6242C48.988 58.1121 49.5612 59.5451 50.5961 60.6141Z"
            fill="#FF808C"
          />
          <path
            d="M69.7749 79.7928L81 83L77.7928 71.7749L69.7749 79.7928Z"
            fill="#FFBC44"
          />
          <path
            d="M61.0194 55.0048L77.7929 71.7783L69.775 79.7962L53.0015 63.0227L61.0194 55.0048Z"
            fill="#FFEF5E"
          />
          <path
            d="M50.5961 60.6141L53.0015 63.0195L61.0194 55.0016L58.614 52.5962C57.545 51.5613 56.112 50.9881 54.6241 51.0002C53.1363 51.0123 51.7128 51.6087 50.6607 52.6608C49.6086 53.7129 49.0122 55.1364 49.0001 56.6242C48.988 58.1121 49.5612 59.5451 50.5961 60.6141Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.7749 79.7928L81 83L77.7928 71.7749L69.7749 79.7928Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M61.0194 55.0048L77.7929 71.7783L69.775 79.7962L53.0015 63.0227L61.0194 55.0048Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="146.75"
            y="27.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            fill="white"
          />
          <rect
            x="146.75"
            y="27.75"
            width="52.5"
            height="52.5"
            rx="26.25"
            stroke="#1E1E1E"
            strokeWidth="1.5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M174.257 51.4468C174.257 52.6813 174.286 53.7074 173.664 54.8046C173.161 55.6974 172.361 56.2456 171.474 56.2456C170.258 56.2456 169.548 55.3197 169.548 53.9489C169.548 51.2514 171.968 50.7604 174.258 50.7604L174.257 51.4468ZM177.449 59.1675C177.24 59.3569 176.936 59.3689 176.703 59.2416C175.649 58.3679 175.462 57.963 174.885 57.1314C173.147 58.902 171.917 59.433 169.665 59.433C167 59.433 164.925 57.7887 164.925 54.498C164.925 51.9278 166.319 50.1803 168.302 49.3235C170.02 48.568 172.42 48.4307 174.256 48.2263V47.8155C174.256 47.0609 174.316 46.1701 173.872 45.5168C173.486 44.9366 172.746 44.6951 172.093 44.6951C170.886 44.6951 169.812 45.3144 169.548 46.596C169.494 46.8816 169.287 47.1641 168.998 47.1792L165.931 46.8455C165.671 46.7894 165.382 46.5789 165.458 46.1841C166.163 42.4606 169.526 41.3363 172.538 41.3363C174.078 41.3363 176.092 41.7471 177.306 42.9135C178.847 44.3524 178.701 46.2723 178.701 48.3626V53.2956C178.701 54.7796 179.318 55.4299 179.895 56.2305C180.1 56.5181 180.143 56.8618 179.885 57.0712C179.237 57.6133 178.087 58.6114 177.457 59.1745L177.449 59.1675Z"
            fill="#1E1E1E"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.017 61.8467C178.263 63.3217 175.27 64.0322 172.547 64.0322C168.511 64.0322 164.604 62.6363 161.443 60.3186C161.166 60.1162 160.961 60.473 161.192 60.7355C164.123 64.0683 167.991 66.0723 172.29 66.0723C175.357 66.0723 178.918 64.8559 181.375 62.5712C181.781 62.1934 181.433 61.6243 181.017 61.8467ZM181.688 64.0673C181.597 64.2947 181.792 64.3879 181.999 64.2145C183.341 63.0923 183.687 60.7415 183.413 60.4028C183.14 60.0661 180.795 59.7755 179.364 60.7806C179.144 60.9349 179.182 61.1483 179.427 61.1183C180.233 61.0221 182.027 60.8056 182.346 61.2165C182.665 61.6273 181.99 63.3147 181.688 64.0673Z"
            fill="#FF9900"
          />
          <path
            d="M170.461 107.234H148.899C148.422 107.234 147.957 107.081 147.572 106.798C147.187 106.515 146.903 106.117 146.761 105.661L144.428 98.1936C144.323 97.8584 144.299 97.5032 144.357 97.1567C144.415 96.8103 144.553 96.4823 144.761 96.1993C144.969 95.9163 145.241 95.6862 145.554 95.5275C145.868 95.3688 146.214 95.286 146.565 95.2858H172.131C172.454 95.2869 172.769 95.182 173.027 94.9871L171.656 107.81C171.52 107.623 171.339 107.472 171.131 107.372C170.922 107.271 170.692 107.224 170.461 107.234Z"
            fill="#C2F3FF"
          />
          <path
            d="M151.725 102.924C151.248 102.923 150.783 102.771 150.399 102.488C150.015 102.206 149.73 101.808 149.588 101.352L147.691 95.2858H146.565C146.214 95.286 145.868 95.3688 145.554 95.5275C145.241 95.6862 144.969 95.9163 144.761 96.1993C144.553 96.4824 144.415 96.8103 144.357 97.1568C144.299 97.5032 144.323 97.8584 144.428 98.1937L146.761 105.661C146.903 106.117 147.187 106.515 147.572 106.798C147.957 107.081 148.422 107.234 148.899 107.234H170.461C170.692 107.224 170.922 107.271 171.131 107.372C171.339 107.473 171.52 107.623 171.656 107.81L172.177 102.924H151.725Z"
            fill="#66E1FF"
          />
          <path
            d="M178.675 89.3118H174.855C174.672 89.3105 174.494 89.3765 174.357 89.4974C174.219 89.6183 174.13 89.7856 174.108 89.9675L173.612 93.976C173.567 94.3374 173.392 94.67 173.119 94.9112C172.846 95.1525 172.495 95.2857 172.131 95.2858H146.565C146.214 95.286 145.868 95.3688 145.554 95.5275C145.241 95.6862 144.969 95.9163 144.761 96.1993C144.553 96.4823 144.415 96.8103 144.357 97.1567C144.299 97.5032 144.323 97.8584 144.428 98.1936L146.761 105.661C146.903 106.117 147.187 106.515 147.572 106.798C147.957 107.081 148.422 107.234 148.899 107.234H170.461C170.857 107.234 171.237 107.391 171.517 107.671C171.797 107.951 171.954 108.331 171.954 108.727C171.954 109.123 171.797 109.503 171.517 109.783C171.237 110.063 170.857 110.221 170.461 110.221H149.552"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.703 98.2728L172.043 104.214"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.541 117.688C153.135 117.688 153.705 117.452 154.125 117.032C154.545 116.612 154.781 116.042 154.781 115.448C154.781 114.854 154.545 114.284 154.125 113.864C153.705 113.444 153.135 113.208 152.541 113.208C151.946 113.208 151.377 113.444 150.957 113.864C150.536 114.284 150.3 114.854 150.3 115.448C150.3 116.042 150.536 116.612 150.957 117.032C151.377 117.452 151.946 117.688 152.541 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M168.969 117.688C169.563 117.688 170.133 117.452 170.553 117.032C170.973 116.612 171.209 116.042 171.209 115.448C171.209 114.854 170.973 114.284 170.553 113.864C170.133 113.444 169.563 113.208 168.969 113.208C168.375 113.208 167.805 113.444 167.385 113.864C166.965 114.284 166.729 114.854 166.729 115.448C166.729 116.042 166.965 116.612 167.385 117.032C167.805 117.452 168.375 117.688 168.969 117.688Z"
            fill="#D7D7D7"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14932">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
AmazonProductListing.displayName = 'AmazonProductListing';
